import { render, staticRenderFns } from "./CardGrade.vue?vue&type=template&id=56b5672f&scoped=true&"
import script from "./CardGrade.vue?vue&type=script&lang=js&"
export * from "./CardGrade.vue?vue&type=script&lang=js&"
import style0 from "./CardGrade.vue?vue&type=style&index=0&id=56b5672f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5672f",
  null
  
)

export default component.exports